export const BOAT_FLEET = [
  {
    id: "harbour-sloop",
    name: "Sloop",
    detail: "Light, direct, and quick to answer the helm.",
    asset: "boatHarbourSloop",
    src: "/game-assets/boats/harbour-sloop.png",
  },
  {
    id: "coastal-cutter",
    name: "Cutter",
    detail: "Fast through changing water, with room to adapt.",
    asset: "boatCoastalCutter",
    src: "/game-assets/boats/coastal-cutter.png",
  },
  {
    id: "steady-catboat",
    name: "Catboat",
    detail: "Broad, steady, and difficult to knock off course.",
    asset: "boatSteadyCatboat",
    src: "/game-assets/boats/steady-catboat.png",
  },
  {
    id: "voyager-ketch",
    name: "Ketch",
    detail: "Balanced for a longer crossing and a bigger crew.",
    asset: "boatVoyagerKetch",
    src: "/game-assets/boats/voyager-ketch.png",
  },
  {
    id: "maker-launch",
    name: "Launch",
    detail: "Practical, compact, and ready to put work aboard.",
    asset: "boatMakerLaunch",
    src: "/game-assets/boats/maker-launch.png",
  },
  {
    id: "crew-tug",
    name: "Tug",
    detail: "Small, sturdy, and happiest helping others move.",
    asset: "boatCrewTug",
    src: "/game-assets/boats/crew-tug.png",
  },
  {
    id: "signal-dhow",
    name: "Dhow",
    detail: "A graceful traveller that follows the signal wind.",
    asset: "boatSignalDhow",
    src: "/game-assets/boats/signal-dhow.png",
  },
] as const;

export type BoatStyleId = (typeof BOAT_FLEET)[number]["id"];

export function isBoatStyleId(value: unknown): value is BoatStyleId {
  return BOAT_FLEET.some((boat) => boat.id === value);
}

export function boatStyleById(id: BoatStyleId | null) {
  return BOAT_FLEET.find((boat) => boat.id === id) ?? null;
}
